import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">快速了解43423漫画网的使用方式和平台特色</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3 flex items-start gap-2">
                <span className="w-5 h-5 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                  <i className="ri-question-line text-primary-600 text-xs"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-7">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}